
export const track = (str?: string) => {
	str = (str || '').toLowerCase();
	str = str.replace(/[^a-z _]/g, ''); // Remove invalid chars
	str = str.replace(/\s+/g, '_'); // Collapse whitespace and replace by _
	str = str.replace(/_+/g, '_'); // Collapse underscores

	if (!str) {
		return undefined;
	}

	return 'ai:' + str;
};
